module.exports = __webpack_public_path__ + "img/imei-sample@2x.4eedacd4.png";